export default function RevenueChart({ subscriptions, settings }) {
  const currency = settings.currency || 'ZMW'
  const currentYear = new Date().getFullYear()
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const monthlyRevenue = months.map((month, index) => {
    const total = subscriptions
      .filter(s => { const d = new Date(s.payment_date); return d.getFullYear() === currentYear && d.getMonth() === index })
      .reduce((sum, s) => sum + Number(s.amount), 0)
    return { month, total }
  })

  const maxValue = Math.max(...monthlyRevenue.map(m => m.total), 1)

  return (
    <div className="bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 p-6">
      <div className="text-xs text-gray-500 uppercase tracking-widest font-semibold mb-6">
        Monthly Revenue {currentYear}
      </div>
      <div className="flex items-end gap-2 h-40">
        {monthlyRevenue.map(({ month, total }) => (
          <div key={month} className="flex-1 flex flex-col items-center gap-1">
            <div className="text-xs text-gray-500 font-mono">{total > 0 ? total : ''}</div>
            <div className="w-full bg-green-600 transition-all" style={{ height: `${(total / maxValue) * 100}%`, minHeight: total > 0 ? '4px' : '0' }} />
            <div className="text-xs text-gray-500">{month}</div>
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-gray-200 dark:border-white/10 flex justify-between text-xs text-gray-500">
        <span>Total: {currency} {monthlyRevenue.reduce((sum, m) => sum + m.total, 0).toLocaleString()}</span>
        <span>Avg/month: {currency} {Math.round(monthlyRevenue.reduce((sum, m) => sum + m.total, 0) / 12).toLocaleString()}</span>
      </div>
    </div>
  )
}